'use strict';

export default class Stackplan {
  constructor() {
  //
  //
  //
  //   let $dataFloors= {
  //     "@odata.context": "http://raine.square.localtest.adelphi.digital/api/public/$metadata#officefloors",
  //     "value": [
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 1,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "EnquireNowTitle": "Enquire Floor",
  //         "officefloorcategories": [
  //           "28e9c364-bba2-45fd-a2cc-fd930d77c410"
  //           ],
  //         "Title": "L06 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "2f0b5c81-cebb-438b-b3fe-f7697a628a8c",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/hero-images/view_e_v1-1.jpg?sfvrsn=d21cd323_2"
  //         }
  //       },
  //       {
  //         "Id": "9afce6d1-be0d-4de4-aa00-eb7a9608144d",
  //         "LastModified": "2018-06-28T04:32:00Z",
  //         "PublicationDate": "2018-06-28T04:32:00Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:32:00Z",
  //         "UrlName": "office-floor",
  //         "FloorSize": 1231231,
  //         "FloorID": 2,
  //         "EnquireNowExternal": "asfasdas",
  //         "EnquireNowLink": "http://google.com",
  //         "EnquireNowTitle": "Enquire Floor",
  //         "officefloorcategories": [
  //           "28e9c364-bba2-45fd-a2cc-fd930d77c410"
  //           ],
  //         "Title": "L07 Office",
  //         "EnquireNowAnchorTag": "asdfa",
  //         "ParentId": "2f0b5c81-cebb-438b-b3fe-f7697a628a8c",
  //         "FloorPlan": null
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 3,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowTitle": "Enquire Floor",
  //         "EnquireNowLink": "",
  //         "officefloorcategories": [],
  //         "Title": "L08 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "2f0b5c81-cebb-438b-b3fe-f7697a628a8c",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/logos/penguins.jpg?sfvrsn=6c34df58_2"
  //         }
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 4,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "EnquireNowTitle": "Enquire Floor",
  //         "officefloorcategories": [],
  //         "Title": "L09 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "2f0b5c81-cebb-438b-b3fe-f7697a628a8c",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/hero-images/view_e_v1-1.jpg?sfvrsn=d21cd323_2"
  //         }
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 5,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "EnquireNowTitle": "Enquire Floor",
  //         "officefloorcategories": [],
  //         "Title": "L10 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "2f0b5c81-cebb-438b-b3fe-f7697a628a8c",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/logos/penguins.jpg?sfvrsn=6c34df58_2"
  //         }
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 1,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "officefloorcategories": [
  //           "28e9c364-bba2-45fd-a2cc-fd930d77c410"
  //           ],
  //         "Title": "Tower 2 L06 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "6fc3e480-5cf8-4946-a73a-2d9c30674f83",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/logos/penguins.jpg?sfvrsn=6c34df58_2"
  //         }
  //       },
  //       {
  //         "Id": "9afce6d1-be0d-4de4-aa00-eb7a9608144d",
  //         "LastModified": "2018-06-28T04:32:00Z",
  //         "PublicationDate": "2018-06-28T04:32:00Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:32:00Z",
  //         "UrlName": "office-floor",
  //         "FloorSize": 1231231,
  //         "FloorID": 2,
  //         "EnquireNowExternal": "asfasdas",
  //         "EnquireNowLink": "http://google.com",
  //         "officefloorcategories": [
  //           "28e9c364-bba2-45fd-a2cc-fd930d77c410"
  //           ],
  //         "Title": "Tower 2 L07 Office",
  //         "EnquireNowAnchorTag": "asdfa",
  //         "ParentId": "6fc3e480-5cf8-4946-a73a-2d9c30674f83",
  //         "FloorPlan": null
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 3,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "officefloorcategories": [],
  //         "Title": "Tower 2 L08 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "6fc3e480-5cf8-4946-a73a-2d9c30674f83",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/logos/penguins.jpg?sfvrsn=6c34df58_2"
  //         }
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 4,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "officefloorcategories": [],
  //         "Title": "Tower 2 L09 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "6fc3e480-5cf8-4946-a73a-2d9c30674f83",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/logos/penguins.jpg?sfvrsn=6c34df58_2"
  //         }
  //       },
  //       {
  //         "Id": "bd8d2727-f9d9-4621-ac79-b44b11b0de4e",
  //         "LastModified": "2018-06-28T05:43:16Z",
  //         "PublicationDate": "2018-06-28T04:12:52Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T04:12:52Z",
  //         "UrlName": "abc",
  //         "FloorSize": 1879,
  //         "FloorID": 5,
  //         "EnquireNowExternal": "http://google.com",
  //         "EnquireNowLink": "http://google.com",
  //         "officefloorcategories": [],
  //         "Title": "Tower 2 L10 Office",
  //         "EnquireNowAnchorTag": "asfa",
  //         "ParentId": "6fc3e480-5cf8-4946-a73a-2d9c30674f83",
  //         "FloorPlan": {
  //           "Id": "a5c890b1-38fc-4fab-8381-f1b4c4472342",
  //           "AlternativeText": "Penguins",
  //           "Url": "http://raine.square.localtest.adelphi.digital/images/librariesprovider5/logos/penguins.jpg?sfvrsn=6c34df58_2"
  //         }
  //       }
  //     ]
  //   };
  //
  //   let $dataTowers = {
  //     "@odata.context": "http://raine.square.localtest.adelphi.digital/api/public/$metadata#towers",
  //     "value": [
  //       {
  //         "Id": "2f0b5c81-cebb-438b-b3fe-f7697a628a8c",
  //         "LastModified": "2018-06-28T03:49:54Z",
  //         "PublicationDate": "2018-06-28T03:49:54Z",
  //         "ExpirationDate": null,
  //         "DateCreated": "2018-06-28T03:49:54Z",
  //         "UrlName": "asdfa",
  //         "Title": "asdfa",
  //         "TowerID": "1adsfa",
  //         "ParentId": "45838aec-da03-4141-9501-9beaf8108188"
  //       },
  //           {
  //             "Id": "6fc3e480-5cf8-4946-a73a-2d9c30674f83",
  //             "LastModified": "2018-06-28T03:47:24Z",
  //             "PublicationDate": "2018-06-28T03:47:24Z",
  //             "ExpirationDate": null,
  //             "DateCreated": "2018-06-28T03:47:24Z",
  //             "UrlName": "abc",
  //             "Title": "Abc",
  //             "TowerID": "t2",
  //             "ParentId": "45838aec-da03-4141-9501-9beaf8108188"
  //           }
  //
  //         ]
  //         };
  //
  //   let $dataAvailable = {
  //   "@odata.context": "http://raine.square.localtest.adelphi.digital/api/public/$metadata#flat-taxa",
  //   "value": [
  //     {
  //       "Id": "42816c97-bb38-4d3d-8f1c-d5f86525b4e5",
  //       "LastModified": "2018-06-28T04:14:33Z",
  //       "Title": "Leased",
  //       "Description": "",
  //       "UrlName": "leased",
  //       "Name": "leased",
  //       "Ordinal": 2,
  //       "TaxonomyId": "ed9fb83b-8d49-43fa-a231-12648caa0e88"
  //     },
  //     {
  //       "Id": "28e9c364-bba2-45fd-a2cc-fd930d77c410",
  //       "LastModified": "2018-06-28T04:14:28Z",
  //       "Title": "Available",
  //       "Description": "",
  //       "UrlName": "available",
  //       "Name": "available",
  //       "Ordinal": 1,
  //       "TaxonomyId": "ed9fb83b-8d49-43fa-a231-12648caa0e88"
  //     }
  //   ]
  // }


let $stackPlans =  $('.stackplan-widget');

$stackPlans.each(function(i, stackplan){
    let $backgroundImageUrl = $(this).data('background-image');
    let $backgroundImage = $(this).find('.stackplan-background-image');
    $backgroundImage.attr('xlink:href', $backgroundImageUrl);
    let $stackPlanWrapper = $(this).find('.stackplan-wrapper');
    let $loader = $(this).find('.loader');

    //show stack plan and hide loader once background image loads
    let myImge = $("<img />").attr("src", $backgroundImageUrl + "?" + new Date().getTime());
    $(myImge).load(function() {
      $stackPlanWrapper.show();
      $loader.addClass('hide');

    });

  })

$stackPlans.each(function(stackPlanIndex, stackPlanItem){

let $dataFloors = $(stackPlanItem).data('floors-api');
let $dataTowers = $(stackPlanItem).data('towers-api');
let $dataAvailable = $(stackPlanItem).data('availability-api');

const $stackPlanWidget = $(stackPlanItem);
let svgWrapperPadding = $stackPlanWidget.find('[data-padding-bottom]').data('padding-bottom');
$stackPlanWidget.find('.stackplan-SVG-wrapper').css('padding-bottom', svgWrapperPadding);

let $dataFloorsArray;
let $dataTowersArray;
let $dataAvailableArray;

$.ajax({
  dataType: "json",
  url: $dataFloors
}).done(function(data) {
   $dataFloorsArray = data.value


  $.ajax({
    dataType: "json",
    url: $dataTowers
  }).done(function(data) {
     $dataTowersArray = data.value


    $.ajax({
      dataType: "json",
      url: $dataAvailable
    }).done(function(data){
       $dataAvailableArray = data.value

        let availableId = "";
        let leasedId = "";
              //grab the available / leased id

        $.each($dataAvailableArray, function(i, ele){
          if( ele.Title.toUpperCase() === "AVAILABLE"){
            availableId = ele.Id
          } else if( ele.Title.toUpperCase() === "LEASED" ){
            leasedId  = ele.Id
          }
        })





        $(document).ready(function(){


            let $stackplan = $stackPlanWidget;
            let stackPlanNoneAvailable = true;
            let stackPlanNoneLeased = true;
            let completeDataTowers = $dataTowersArray;



            $.each( $dataTowersArray , function(i, tower){
              completeDataTowers[i].Floors = [];


              if($dataTowersArray.length-1 === i){
                $.each( $dataFloorsArray , function(i, floor){

                  $.each( $dataTowersArray , function(i, tower){
                      let towerId = tower.Id;
                      let floorTowerId = floor.ParentId;



                      if( towerId === floorTowerId ){ //this is at one floor at one towers

                        let dataFloorLabelSelector = '[data-floor=' + floor.FloorID + '] [data-floor-label]';
                        let dataAvailableFloorLineSelector = '[data-floor="' + floor.FloorID + '"][data-floor-available="true"] [data-floor-line]';
                        let notAvailableNoPlanFloorSelector = '[data-floor="' + floor.FloorID + '"]:not([data-floor-image-url])';
                        let notAvailableFloorSelector = '[data-floor="' + floor.FloorID + '"][data-floor-available="false"]';
                        let availableFloorSelector = '[data-floor="' + floor.FloorID + '"][data-floor-available="true"]';

                        let tableSelector = '.js-stackplan-table'
                        let dataFloorLabelTitle = floor.Title;
                        dataFloorLabelTitle = dataFloorLabelTitle.toUpperCase();

                        let dataTowerIdSelector = '[data-tower=' + tower.TowerID + ']';
                        let $tower = $stackplan.find(dataTowerIdSelector);

                        let $table = $stackplan.find(tableSelector);

                        let tableFloorsHtml = '';

                        //create table markup

                        // tableFloorHtml




                        $tower.find(dataFloorLabelSelector).text(dataFloorLabelTitle);

                        let dataFloorSelector = '[data-floor=' + floor.FloorID + ']'

                        let $dataFloor = $tower.find(dataFloorSelector);
                        let dataFloorImageURL = '';
                        let dataFloorImageALT = '';
                        let dataFloorTitle = '';
                        let dataFloorSize = '';
                        let dataFloorButtonTitle = '';
                        let dataFloorButtonURL = '';

                        //set availability
                        let availabilityId = floor.officefloorcategories[0];



                        if(availabilityId === availableId || availabilityId === undefined){
                          $dataFloor.attr('data-floor-available',true);
                          stackPlanNoneAvailable = false;
                          floor.Available = true;

                        } else if( availabilityId === leasedId ){
                            $dataFloor.attr('data-floor-available', false);
                            stackPlanNoneLeased = false;
                            floor.Available = false;
                        }

                        //if available show line and label
                          $tower.find(dataAvailableFloorLineSelector).css('display','inline');


                        dataFloorTitle = floor.Title; //can be null
                        dataFloorSize = floor.FloorSize; //can be null

                        if(floor.EnquireNowTitle){
                          dataFloorButtonTitle = floor.EnquireNowTitle;
                        }
                        if(floor.EnquireNowLink){
                         dataFloorButtonURL = floor.EnquireNowLink;
                       }



                        if(floor.FloorPlan){
                          dataFloorImageURL = floor.FloorPlan.Url;
                          dataFloorImageALT = floor.FloorPlan.AlternativeText;
                        }


                        $dataFloor.attr('data-floor-image-url',dataFloorImageURL);
                        $dataFloor.attr('data-floor-image-alt', dataFloorImageALT);
                        $dataFloor.attr('data-floor-title',dataFloorTitle);
                        $dataFloor.attr('data-floor-size', dataFloorSize);

                        $dataFloor.attr('data-floor-button-title',dataFloorButtonTitle);
                        $dataFloor.attr('data-floor-button-url',dataFloorButtonURL);////////////////////

                        $table.attr('data-floor-image-url',dataFloorImageURL);
                        $table.attr('data-floor-image-alt', dataFloorImageALT);
                        $table.attr('data-floor-title',dataFloorTitle);
                        $table.attr('data-floor-size', dataFloorSize);



                        //floor level enquire button overrides the widget level settings
                        let widgetFloorPlanButtonTitle = $stackplan.data('button-title');
                        let widgetFloorPlanButtonURL = $stackplan.data('button-url');
                        floor.ButtonTitle = dataFloorButtonTitle;
                        floor.EnquireNowLink = dataFloorButtonURL;

                        let updateFloorPlanButtonData = function(){
                          if(!widgetFloorPlanButtonTitle && !dataFloorButtonTitle){

                          }
                          if(widgetFloorPlanButtonTitle){
                            //if there is a widget set enquire button to use that data
                            if(!dataFloorButtonTitle){
                              $dataFloor.attr('data-floor-button-title',widgetFloorPlanButtonTitle);
                              floor.ButtonTitle = widgetFloorPlanButtonTitle;
                            }

                          }
                          if(widgetFloorPlanButtonURL ){
                            if(!dataFloorButtonURL){
                              $dataFloor.attr('data-floor-button-url',widgetFloorPlanButtonURL);
                              floor.EnquireNowLink = widgetFloorPlanButtonURL
                            }

                          }
                        };

                        updateFloorPlanButtonData();
                        //dont let tabindex users hover over levels without a floor plan image
                        $(availableFloorSelector).attr('tabindex', "0");



                        (completeDataTowers[i].Floors).push(floor)
                      }
                  })


                  if(($dataFloorsArray.length)-1 === i){
                    //after creating complete data set - iterate through each to produce table.

                    $.each(completeDataTowers, function(i, ele){
                      let tableTowerHtmlStart = `
                      <tr class="stackplan-table-heading tower-title" >
                        <td colspan="3" >${completeDataTowers[i].Title}</td>
                      </tr>

                      `

                      let tableTowerHtmlEnd =`


                      `

                      let tableAllFloorsHtml ='';


                      let completeHtml = '';

                      if(completeDataTowers[i].Floors.length){
                        $.each(completeDataTowers[i].Floors, function(j, floor){

                          let tableFloorHtml = '';
                          let tableFloorHtmlMid = '';
                          let floorSizeHtml ='';
                          let floorImageUrl ='';
                          if(floor.FloorPlan && floor.Available){

                            tableFloorHtml = `
                            <tr class="stackplan-table-floor" tabindex="0" data-floor-available=${floor.Available}
                                data-floor="${floor.FloorID}"`

                          if(floor.FloorPlan.Url){
                              floorImageUrl= `data-floor-image-url="${floor.FloorPlan.Url}"`
                            }

                            tableFloorHtmlMid=
                                `data-floor-image-alt="${floor.FloorPlan.AlternativeText}"
                                data-floor-title="${floor.Title}"
                                data-floor-size="${floor.FloorSize}"
                                data-floor-button-title="${floor.ButtonTitle}"
                                data-floor-button-url="${floor.EnquireNowLink}">
                                  <td class="stackplan-table-floor-title">${floor.Title}</td>
                                  <td class="right-col">
                                `

                                if(floor.FloorSize){
                                  floorSizeHtml = `<div class="stackplan-table-floor-size">${floor.FloorSize}</div>`;
                                }

                                var tableFloorHtmlEnding =
                                `
                                    <div class="stackplan-table-floor-availability">Available</div>
                                  </td>
                                  <td class="stackplan-table-floor-arrow-wrapper">
                                    <div class="stackplan-table-floor-arrow"></div>
                                  </td>
                                </tr>
                            `
                            tableFloorHtml = tableFloorHtml + floorImageUrl + tableFloorHtmlMid + floorSizeHtml + tableFloorHtmlEnding;

                          }else if(floor.Available){
                            tableFloorHtml = `
                            <tr class="stackplan-table-floor" data-floor-available=${floor.Available}
                                data-floor="${floor.FloorID}"
                                data-floor-title="${floor.Title}"
                                data-floor-size="${floor.FloorSize}"
                                data-floor-image-url
                                data-floor-button-title="${floor.ButtonTitle}"
                                data-floor-button-url="${floor.EnquireNowLink}">
                                  <td class="stackplan-table-floor-title">${floor.Title}</td>
                                  <td class="right-col">`



                            if(floor.FloorSize){
                              floorSizeHtml = `<div class="stackplan-table-floor-size">${floor.FloorSize}</div>`;
                            }


                              var tableFloorHtmlEnding =
                                    `
                                    <div class="stackplan-table-floor-availability">Available</div>
                                  </td>
                                  <td class="stackplan-table-floor-arrow-wrapper">
                                    <div class="stackplan-table-floor-arrow"></div>
                                  </td>
                                </tr>
                            `
                            tableFloorHtml = tableFloorHtml + floorSizeHtml + tableFloorHtmlEnding;
                          }

                          tableAllFloorsHtml= tableAllFloorsHtml + tableFloorHtml ;
                          if((completeDataTowers[i].Floors).length === j+1 ){
                              completeHtml = tableTowerHtmlStart + tableAllFloorsHtml + tableTowerHtmlEnd;

                              $stackplan.find('.js-stackplan-table').append(completeHtml);
                          }
                        })
                      }


                    })
                  }


            });

              }
            })







            //hide/show Legend
            if(stackPlanNoneAvailable){
              $stackplan.find("[data-legend='Available']").css('display','none');
            }
            if(stackPlanNoneLeased){
              $stackplan.find("[data-legend='Leased']").css('display','none');
            }










            let $stackPlanModal= $stackPlanWidget.find('.stackplan-modal-wrapper');
            let $floors = $stackPlanWidget.find('[data-floor][data-floor-available="true"], tr.stackplan-table-floor[data-floor-available="true"]');



            $stackPlanModal.iziModal({
              headerColor: '#26A69A',
              width: '50%',
              overlayColor: 'rgba(255, 255, 255, 0.6)',
              fullscreen: true,
              width: '80%',
              transitionIn: 'fadeIn',
              transitionOut: 'fadeOut',
              arrowKeys: false,
              navigateArrows: false,
              closeButton: false,
              overlayClose: false,
            });

            $floors.keypress(function(e) {
              if(e.which == 13) {
                  $(this).trigger('click');
              }
            });

            $stackPlanModal.find('[data-izimodal-close]').keypress(function(e) {
              if(e.which == 13) {
                $stackPlanModal.iziModal('close')
              }
            });

            $floors.on('mouseenter',function(e){
              $(e.target).addClass('hide');
            })
            $floors.on('mouseleave',function(e){
              $(e.target).removeClass('hide');
            })


            $floors.on('touchend click', function(e){

              if(!$(this).parents('.stackplan-table-body').length){

                if(e.type !=='click'){
                  if(!$(this).hasClass("tapped")){
                    $stackPlanWidget.find('.tapped[data-floor]').removeClass('tapped');
                    $(this).addClass("tapped")
                    return false;
                  }
                }else{
                  e.preventDefault();
                  e.stopPropagation();

                  if($(this).hasClass("tapped")){
                    $(this).removeClass("tapped")
                    return false;
                  }
                }
              }


              if(e.type =='click' || $(this).hasClass("tapped") ){


              let floorTitle = $(this).attr('data-floor-title');
              let floorSize = $(this).attr('data-floor-size');
              let floorImageURL = $(this).attr('data-floor-image-url');
              let floorImageALT = $(this).attr('data-floor-image-alt');

              let floorButtonTitle = $(this).attr('data-floor-button-title');
              let floorButtonURL = $(this).attr('data-floor-button-url');

              $stackPlanModal.find('.stackplan-modal-floor-title').html(floorTitle);

              if(floorSize !== "null" && floorSize){
                $stackPlanModal.find('.stackplan-modal-floor-size').html(floorSize);
                $stackPlanModal.find('.stackplan-modal-floor-size').show();
              } else{
                $stackPlanModal.find('.stackplan-modal-floor-size').hide();
              }
              if(floorImageURL){
                $stackPlanModal.find('.stackplan-modal-floor-image').show();
                  $stackPlanModal.find('.stackplan-modal-floor-image').attr('src',floorImageURL);
              } else{
                $stackPlanModal.find('.stackplan-modal-floor-image').hide();
              }

              $stackPlanModal.find('.stackplan-modal-floor-image').attr('alt',floorImageALT);

              if(floorButtonTitle ){
                $stackPlanModal.find('.stackplan-modal-content .cta span').html(floorButtonTitle);
                $stackPlanModal.find('.stackplan-modal-content .cta').attr('href',floorButtonURL);
                $stackPlanModal.find('.stackplan-modal-content .cta').show();
              } else{
                  $stackPlanModal.find('.stackplan-modal-content .cta').hide();
              }

              let $floorHighlighted = $(this);

                if(floorImageURL){
                  $stackPlanModal.find('.stackplan-modal-floor-image').one("load", function() {
                      $stackPlanModal.iziModal('open');
                      $stackPlanModal.focus();
                      if($floorHighlighted.hasClass("tapped")){
                        $floorHighlighted.removeClass("tapped")
                      }

                  }).each(function() {
                    if(this.complete) $(this).load();
                  });
                }else if(!floorImageURL){
                  $stackPlanModal.iziModal('open');
                  $stackPlanModal.focus();
                  if($floorHighlighted.hasClass("tapped")){
                    $floorHighlighted.removeClass("tapped")
                  }
                }



              }
              })


          })

          //end of constructor

      })//end of done function for ajax json
    })//end of done function for ajax json
  })//end of done function for ajax json

})  //end of iterating over each stack plan-widget

  }
}
